// extracted by mini-css-extract-plugin
export default {"legend":"DataCollectorsPerformanceTableLegend_legend__Hu3qj","label":"DataCollectorsPerformanceTableLegend_label__soFJE","rtl":"DataCollectorsPerformanceTableLegend_rtl__X7SGb"};